module.exports = __webpack_public_path__ + "assets/img/c3.a00673c7.jpg";